import React from "react";
export function Footer() {
  return <footer className="bg-[#0A1B40] px-4 pb-32 pt-12 text-center" data-id="element-203" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl" data-id="element-204" data-mp="208ce79corfro">
        <p className="text-lg font-black uppercase text-white" data-id="element-205" data-mp="209ng13mkmdg5">Autism Communication Support Blueprint™</p>
        <p className="mt-2 text-sm font-semibold text-white/70" data-id="element-206" data-mp="2f2h6tl7amg04">
          A Practical Educational System for Individualized Autism Communication Support Planning
        </p>
        <p className="mt-1 text-sm font-semibold text-white/70" data-id="element-207" data-mp="1mgny6uzbg75f">6 Digital Volumes + 5 Specialized Bonuses</p>
        <p className="mt-6 text-xs font-semibold leading-relaxed text-white/55" data-id="element-208" data-mp="1hiw908q22z4x">
          <strong className="text-white/75" data-id="element-209" data-mp="1w6r0jlsbuxgf">Educational Disclaimer:</strong> This product is intended for educational
          and professional planning purposes. It does not replace individualized assessment, professional clinical
          judgment, specialist training, or applicable professional standards. Communication support approaches should
          respect each individual’s autonomy, preferences, access needs, and communication goals.
        </p>
        <p className="mt-6 text-xs font-semibold text-white/55" data-id="element-210" data-mp="1ij5pnwf9vphh">
          © 2026 Autism Communication Support Blueprint™. All rights reserved.
        </p>
      </div>
    </footer>;
}